import React, { useState, useEffect } from "react";
import Dropdown from "./DropDown";
import axios from "axios";
// import * as XLSX from "xlsx";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { useSelector, useDispatch } from "react-redux";
// import { AlertOptionsData } from "../../Redux/Reducers/Common/Alerts";
import { FaAnglesLeft } from "react-icons/fa6";
import { SelecYearData } from "../../Redux/Reducers/Common/Year";
import { DateDetailsData } from "../../Redux/Reducers/Common/AssessmentDate";
import { Testcolors } from "../../ReusableComponents/CommonFunctions";
export function Grade(props) {
  const [SelectGrade, SetSelectGrade] = useState(props.selected || "Grade 6");
  useEffect(() => {
    props.PostGrade(SelectGrade.split(" ")[1]);
  }, []);

  const handleselectGrade = (e) => {
    props.PostGrade(e.target.value.split(" ")[1]);
    SetSelectGrade(e.target.value);
  };
  return (
    <Dropdown
      className={props.className}
      id={props.id}
      options={[
        "Grade 1",
        "Grade 2",
        "Grade 3",
        "Grade 4",
        "Grade 5",
        "Grade 6",
        "Grade 7",
        "Grade 8",
        "Grade 9",
        "Grade 10",
        "Grade 11",
        "Grade 12",
      ]}
      onChange={(e) => {
        handleselectGrade(e);
      }}
      Displayname="Select Grade"
      selectoption={SelectGrade}
    />
  );
}

export function Month(props) {
  const [SelectMonth, SetSelectMonth] = useState(props.selected || "January");
  useEffect(() => {
    props.PostMonth(SelectMonth.split(" ")[1]);
  }, []);

  const handleselectMonth = (e) => {
    props.PostMonth(e.target.value.split(" ")[1]);
    SetSelectMonth(e.target.value);
  };
  return (
    <Dropdown
      className={props.className}
      id={props.id}
      options={["January", "February"]}
      onChange={(e) => {
        handleselectMonth(e);
      }}
      Displayname="Select Month"
      selectoption={SelectMonth}
    />
  );
}

export function Year(props) {
  const dispatch = useDispatch();
  const currentYear = new Date().getFullYear();
  const startYear = parseInt(process.env.REACT_APP_Startyear);
  const [Year, SetYear] = useState(
    useSelector((state) => state.SelecYearData.SYear) || currentYear
  );
  const Totalyears = Array.from(
    { length: currentYear - startYear + 1 },
    (_, index) => startYear + index
  );
  useEffect(() => {
    dispatch(SelecYearData({ SYear: "" }));
    dispatch(SelecYearData({ SYear: Year || startYear }));
  }, [Year]);

  return (
    <Dropdown
      className={props.className}
      options={Totalyears}
      onChange={(e) => {
        SetYear(e.target.value);
        dispatch(DateDetailsData({ DateDetails: "" }));
      }}
      selectoption={Year}
    />
  );
}

// export function Assessmentdate(props) {
//   const [SelectAssessmentDate, SetSelectAssessmentDate] = useState();
//   const [AssessmentDates, SetAssessmentDates] = useState();
//   const [CData, SetCData] = useState();
//   const ASSDATE = async (e) => {
//     SetAssessmentDates([]);
//     await axios
//       .get(
//         process.env.REACT_APP_API_BASE_URL +
//           `/CommonAPI/GetYearWiseAssessmentByInstitute?Year=${props.PostYear}&AssessmentType=${props.Asstype}&InstituteId=${props.Institute}`,
//         { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
//       )
//       .then((res) => {
//         SetCData(res.data);
//         SetAssessmentDates(res.data.map((date) => date.papername));

//         if (props.selected) {
//           const value = res.data.findIndex(
//             (obj) => obj.contestCreationId === props.selected
//           );
//           if (value < 0) {
//             SetSelectAssessmentDate(res.data[res.data.length - 1]?.papername);
//             props.Postdate({
//               Name: res.data[res.data.length - 1]?.papername,
//               code: res.data[res.data.length - 1]?.contestCreationId,
//             });
//           } else {
//             SetSelectAssessmentDate(res.data[value].papername);
//             props.Postdate({
//               Name: res.data[value].papername,
//               code: res.data[value].contestCreationId,
//             });
//           }
//         } else {
//           SetSelectAssessmentDate(res.data[res.data.length - 1]?.papername);
//           props.Postdate({
//             Name: res.data[res.data.length - 1]?.papername,
//             code: res.data[res.data.length - 1]?.contestCreationId,
//           });
//         }
//       })
//       .catch((err) => {
//         console.log(err);
//       });
//   };
//   useEffect(() => {
//     if (props.PostYear && props.Asstype) {
//       ASSDATE();
//     }
//   }, [props.selected, props.Institute, props.PostYear, props.Asstype]);
//   const handleselectDate = (e) => {
//     const value = CData.findIndex((obj) => obj.papername === e.target.value);
//     if (value < 0) {
//       SetSelectAssessmentDate(-1);
//       // props.Postdate(-1);
//       props.Postdate({ code: -1 });
//     } else {
//       SetSelectAssessmentDate(e.target.value);
//       props.Postdate({
//         Name: CData[value].papername,
//         code: CData[value].contestCreationId,
//       });
//       // props.Postdate(CData[value].contestCreationId);
//     }
//   };
//   return (
//     <>
//       {AssessmentDates && (
//         <Dropdown
//           className={props.className}
//           options={AssessmentDates}
//           /*labelname="Date : "*/ onChange={(e) => {
//             handleselectDate(e);
//           }}
//           Displayname="Select Date"
//           selectoption={SelectAssessmentDate}
//           labelname={props.labelname}
//         />
//       )}
//     </>
//   );
// }

export function Section(props) {
  const [Section, SetSection] = useState(props.selected);
  const HandleSelectsection = (e) => {
    SetSection(e.target.value);
    if (e.target.value.split(" ")[1] != "Section") {
      props.Postsection(e.target.value.split(" ")[1]);
    } else {
      props.Postsection(-1);
    }
  };
  return (
    <Dropdown
      className={props.className}
      id={props.id}
      options={props.Options}
      onChange={(e) => HandleSelectsection(e)}
      Displayname="Select Section"
      selectoption={Section}
    />
  );
}

export function SUbjects(props) {
  const [Subject, SetSubject] = useState(props.selected);
  const HandleSelectSubject = (e) => {
    SetSubject(e.target.value);
    if (e.target.value != "Select Subject") {
      props.Postsubject(e.target.value);
    } else {
      props.Postsubject(-1);
    }
  };
  useEffect(() => {
    SetSubject(props.selected);
  }, [props.selected]);
  return (
    <Dropdown
      className={props.className}
      options={props.Options}
      onChange={(e) => HandleSelectSubject(e)}
      Displayname="Select Subject"
      selectoption={Subject}
    />
  );
}

export function AssessmentName(e) {
   const types = { 
    1: "SODHANA Assessment",
    2: "SADHANA Assessment",
    3: "SAMAGRA Assessment",
  };

  return types[e] || "";
  // switch (e) {
  //   case 1:
  //     return(<> <span style={{color:Testcolors(e)}}>{process.env.REACT_APP_NCLEXAMPTYPE1}</span> Assessment</> );
  //   case 2:
  //     return (<><span style={{color:Testcolors(e)}}>{process.env.REACT_APP_NCLEXAMPTYPE2}</span> Assessment</>);
  //   case 3:
  //     return (<><span style={{color:Testcolors(e)}}>{process.env.REACT_APP_NCLEXAMPTYPE3}</span> Assessment</>);
  // }
}

export function CAssessmentName(e) {
 switch (e) {
    case 1:
      return(<> <span style={{color:Testcolors(e)}}>{process.env.REACT_APP_NCLEXAMPTYPE1}</span> Assessment</> );
    case 2:
      return (<><span style={{color:Testcolors(e)}}>{process.env.REACT_APP_NCLEXAMPTYPE2}</span> Assessment</>);
    case 3:
      return (<><span style={{color:Testcolors(e)}}>{process.env.REACT_APP_NCLEXAMPTYPE3}</span> Assessment</>);
  }
}
// export function TabChange(props) {
//   return (
//     <>
//       <div className="dflex TestButtons">
//         <div
//           className={props.AssessmenType === 1 ? "TabSelect" : "TabNotSelect"}
//           onClick={() => props.onClick(1)}
//         >
//           <img
//             src={`${props.AssessmenType === 1
//                 ? "/Sodhana-Active.svg"
//                 : "/Sodhana-InActive.svg"
//               }`}
//             alt="Sodhana"
//           />{" "}
//           SODHANA
//         </div>
//         <div
//           className={props.AssessmenType === 2 ? "TabSelect" : "TabNotSelect "}
//           onClick={() => props.onClick(2)}
//         >
//           <img
//             src={`${props.AssessmenType === 2
//                 ? "/Sadhana-Active.svg"
//                 : "/Sadhana-InActive.svg"
//               }`}
//             alt="Sadhana"
//           />{" "}
//           SADHANA
//         </div>
//       </div>
//     </>
//   );
// }

export function NumberToRoman(Num) {
  const romanNumerals = {
    M: 1000,
    CM: 900,
    D: 500,
    CD: 400,
    C: 100,
    XC: 90,
    L: 50,
    XL: 40,
    X: 10,
    IX: 9,
    V: 5,
    IV: 4,
    I: 1,
  };

  let roman = "";
  for (let key in romanNumerals) {
    while (Num >= romanNumerals[key]) {
      roman += key;
      Num -= romanNumerals[key];
    }
  }
  return roman;
}

export function exportToExcel(
  data,
  fileName,
  multipleSheets,
  sheetName,
  Heading,
  AFilter
) {
  const EXCEL_TYPE =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

  const createWorkbook = async () => {
    const workbook = new ExcelJS.Workbook();

    if (multipleSheets) {
      data.forEach((item) => {
        const { sheetName, details } = item;
        const worksheet = workbook.addWorksheet(sheetName);
        if (details.length > 0) {
          const columns = Object.keys(details[0]).map((key) => ({
            header: key,
            key: key,
            width: key.length < 20 ? 20 : key.length,
          }));
          worksheet.columns = columns;
          details.forEach((row) => worksheet.addRow(row));
          worksheet.getRow(1).font = { bold: true };
        }
      });
    } else {
      const worksheet = workbook.addWorksheet(sheetName);

      if (data.length > 0) {
        const columns = Object.keys(data[0]).map((key) => ({
          header: key,
          key: key,
          width: key.length + 5,
        }));
        worksheet.columns = columns;
        if (Heading) {
          worksheet.mergeCells(1, 1, 2, columns.length);
          worksheet.getCell(2, 1).value = Heading;
          worksheet.getCell("A1").alignment = {
            horizontal: "center",
            vertical: "middle",
          };
          worksheet.getRow(1).font = { bold: true };
          // Add a new row for the column headers
          worksheet.getRow(1).eachCell((cell) => {
            cell.fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: { argb: "95b3d7" },
            };
          });
          const columnHeaders = columns.map((column) => column.header);
          worksheet.addRow(columnHeaders);
          worksheet.getRow(3).font = { bold: true };
          if (AFilter) {
            worksheet.autoFilter = {
              from: "A3",
              to: `${String.fromCharCode(64 + columns.length)}3`,
            };
            if (worksheet.length > 0) {
              const filterRange = {
                from: `${worksheet[0]}1`,
                to: `${worksheet[worksheet.length - 1]}1`,
              };
              worksheet.autoFilter = filterRange;
            }
          }
        } else {
          worksheet.getRow(1).font = { bold: true };
        }

        data.forEach((row) => worksheet.addRow(row));
        worksheet.eachRow((row, rowNumber) => {
          row.eachCell((cell, colNumber) => {
            cell.border = {
              top: { style: "thin" },
              left: { style: "thin" },
              bottom: { style: "thin" },
              right: { style: "thin" },
            };
          });
        });
      }
    }

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: EXCEL_TYPE });
    saveAs(blob, `${fileName}.xlsx`);
  };

  createWorkbook();
}

export function Dateformat(date) {
  const dateParts = date.split(/[\/\. -]/);
  if (dateParts) {
    let day = dateParts[0];
    let month = dateParts[1];
    let year = dateParts[2];
    // Normalize month and day values
    let monthNum = parseInt(month, 10);
    let dayNum = parseInt(day, 10);
    // Swap day and month if necessary
    if (monthNum > 12) {
      [day, month] = [month, day];
    }

    return `${day.padStart(2, "0")}-${month.padStart(2, "0")}-${year}`;
  } else {
    return date;
  }
}

export function TabViews(props) {
  return (
    <>
      <div className="Tabs-Align">
        {props.Tabs?.map((tab, index) => (
          <div
            key={index}
            onClick={() => props.onClick(tab)}
            className={props.Selectedtab === tab ? "Activetab" : "Inactivetab"}
          >
            {tab}
          </div>
        ))}
      </div>
    </>
  );
}

export function TabViewsApi(props) {
  const [Grades, SetGrades] = useState();
  const [InitialGrade, SetInitialGrade] = useState(props.Selectedtab);
  const items = useSelector((state) => state.userDetailsData.LoginDetails);

  const GradesApi = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/School/GetClassWiseStudentCount?SchoolId=${props.SChoolID}&Section=All`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        if (res.data[0].class) {
          const sortedData = res.data.sort((a, b) => a.class - b.class);
          const Grades = sortedData.filter((item) => item.class);
          SetGrades(Grades);

          if (props.Selectedtab === "Grade undefined") {
            props.StoreTabchange(Grades[0].class);
            SetInitialGrade(`Grade ${Grades[0].class}`);
          } else {
            SetInitialGrade(props.Selectedtab);
          }
        } else {
          SetGrades();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    GradesApi();
  }, [props.Selectedtab, props.SChoolID]);
  return (
    <TabViews
      Tabs={Grades?.map((item) => `Grade ${item.class}`)}
      onClick={(e) => props.StoreTabchange(e.split(" ")[1])}
      Selectedtab={InitialGrade}
    />
  );
}

export function BackNavigation(props) {
  return (
    <div className="dflex">
      {/* style={{ justifyContent: "flex-end" }} */}
      <div className="Buttons BackNavigation" onClick={props.Navigation}>
        <FaAnglesLeft />
        Back{props.Text}
      </div>
    </div>
  );
}

export function Alert() {
  const dispatch = useDispatch();
  // const USMessage = useSelector((state) => state.AlertOptionsData);

  // {
  //   USMessage?.Status &&
  //     setTimeout(() => {
  //       // dispatch(AlertOptionsData({ Status: false, Message: "", color: "" }));
  //     }, 6000);
  // }
  return (
    <>
      {/* {USMessage?.Status && (
        <div
          className={`Success-Message ${USMessage.color && USMessage.color}`}
        >
          {USMessage.Message}
        </div>
      )} */}
    </>
  );
}
